import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles,
} from "@material-ui/core";
import CustomEmptyComponent from "components/CustomEmptyComponent";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { availableOnlySuperAdminAndAdmin } from "utils/validation";
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    padding: "1rem",
  },
  summaryButton: {
    position: "relative",
    top: 20,
    padding: "8px 16px",
  },
  academicYearLabel: {
    marginTop: "5px",
  },
  MuiAccordionSummary: {
    "& .MuiAccordionSummary-content": {
      margin: "15px 0px 5px",
    },
  },
});

const CcaScheduleDisabledComponent = ({ schoolId }: any) => {
  const classes = useStyles();
  return (
    <Accordion defaultExpanded>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="cca-student-schedule-content"
        id="cca-student-schedule-header"
        className={classes.MuiAccordionSummary}
      >
        <h3 className={classes.academicYearLabel}>CCA Student Schedules</h3>
      </AccordionSummary>
      <AccordionDetails>
        <CustomEmptyComponent
          resource="ccaRateCharts"
          title="The CCA school setting is disabled"
          caption="Please enable the CCA school setting in the school setting summary to show the CCA student schedule."
          url={`/schools/${schoolId}/show`}
          buttonLabel="Go to School Setting"
          buttonIcon={<KeyboardBackspaceIcon />}
          hasCreate={availableOnlySuperAdminAndAdmin()}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default CcaScheduleDisabledComponent;
